import { action, fsa } from "ts-action";
import {
  SET_IS_LOADING,
  SET_STATE_CHANGED_INFO,
  SET_STATE_CHANGED_SETTINGS,
  SET_USER_INFO,
  SET_USER_SETTINGS,
  UPDATE_USER_INFO,
  UPDATE_USER_SETTINGS,
} from "./actionTypes";
import { UserInformationReducer, UserSettingsReducer } from "./types";

export const setUserSettings = action(
  SET_USER_SETTINGS,
  fsa<{
    userSettings: UserSettingsReducer;
  }>()
);

export const setUserInfo = action(
  SET_USER_INFO,
  fsa<{
    userInfo: UserInformationReducer;
  }>()
);

export const updateUserSettings = action(
  UPDATE_USER_SETTINGS,
  fsa<{
    userSettings: UserSettingsReducer;
  }>()
);

export const updateUserInfo = action(
  UPDATE_USER_INFO,
  fsa<{
    userInfo: UserInformationReducer;
  }>()
);

export const setStateChangedInfo = action(
  SET_STATE_CHANGED_INFO,
  fsa<{
    newState: boolean;
  }>()
);

export const setStateChangedSettings = action(
  SET_STATE_CHANGED_SETTINGS,
  fsa<{
    newState: boolean;
  }>()
);

export const setIsLoading = action(
  SET_IS_LOADING,
  fsa<{
    isLoading: boolean;
  }>()
);
